<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Bear Hunting</span></p>
<p class="p0">By R.W. Clinger</p>
<p class="p1"><a id="a4"></a><a href="#/005#a61">Part 1: Blue Danning</a></p>
<p><a href="#/005#a62">Chapter 1: Bear Blog, March 28</a></p>
<p><a href="#/006#a63">Chapter 2: April Fool’s Day</a></p>
<p><a href="#/007#a64">Chapter 3: What Blue Doesn’t Know</a></p>
<p><a href="#/008#a65">Chapter 4: King’s Barbells and Boxing</a></p>
<p><span href="#/009#a66" title="Link target outside of Sample">Chapter 5: When A Stranger Calls</span></p>
<p><span href="#/010#a67" title="Link target outside of Sample">Chapter 6: Cliffy’s Cafe</span></p>
<p><span href="#/011#a68" title="Link target outside of Sample">Chapter 7: The Bear’s Den</span></p>
<p><span href="#/012#a69" title="Link target outside of Sample">Chapter 8: Show Me Your Chest</span></p>
<p><span href="#/013#a70" title="Link target outside of Sample">Chapter 9: Memorabilia</span></p>
<p><span href="#/014#a71" title="Link target outside of Sample">Chapter 10: Bear Blog, April 4</span></p>
<p> </p>
<p class="p1"><span href="#/015#a72" title="Link target outside of Sample">Part 2: Grant Stevens</span></p>
<p><span href="#/015#a73" title="Link target outside of Sample">Chapter 11: The Whiskey Club</span></p>
<p><span href="#/016#a74" title="Link target outside of Sample">Chapter 12: The Musician</span></p>
<p><span href="#/017#a75" title="Link target outside of Sample">Chapter 13: A Drink on Me</span></p>
<p><span href="#/018#a76" title="Link target outside of Sample">Chapter 14: Homework on You</span></p>
<p><span href="#/019#a77" title="Link target outside of Sample">Chapter 15: Walk this Road Tonight</span></p>
<p><span href="#/020#a78" title="Link target outside of Sample">Chapter 16: Beautiful Bodies</span></p>
<p><span href="#/021#a79" title="Link target outside of Sample">Chapter 17: Lay with Me Awhile</span></p>
<p><span href="#/022#a80" title="Link target outside of Sample">Chapter 18: It’s Alright…Alright</span></p>
<p><span href="#/023#a81" title="Link target outside of Sample">Chapter 19: Blue Visits</span></p>
<p><span href="#/024#a82" title="Link target outside of Sample">Chapter 20: Bear Blog, May 6</span></p>
<p> </p>
<p class="p1"><span href="#/025#a83" title="Link target outside of Sample">Part 3: Denver Rawlston</span></p>
<p><span href="#/025#a84" title="Link target outside of Sample">Chapter 21: Bump Into His Skin</span></p>
<p><span href="#/026#a85" title="Link target outside of Sample">Chapter 22: Holiday Proposition</span></p>
<p><span href="#/027#a86" title="Link target outside of Sample">Chapter 23: On Bretton Way</span></p>
<p><span href="#/028#a87" title="Link target outside of Sample">Chapter 24: What Toby Does</span></p>
<p><span href="#/029#a88" title="Link target outside of Sample">Chapter 25: What Toby Reads</span></p>
<p><span href="#/030#a89" title="Link target outside of Sample">Chapter 26: What Toby Watches</span></p>
<p><span href="#/031#a90" title="Link target outside of Sample">Chapter 27: What Toby Continues to Watch</span></p>
<p><span href="#/032#a91" title="Link target outside of Sample">Chapter 28: Muddled</span></p>
<p><span href="#/033#a92" title="Link target outside of Sample">Chapter 29: Getting to Know Denver</span></p>
<p><span href="#/034#a93" title="Link target outside of Sample">Chapter 30: Bear Blog, August 1</span></p>
<p> </p>
<p class="p1"><span href="#/035#a94" title="Link target outside of Sample">Part 4: Carey Cunningham</span></p>
<p><span href="#/035#a95" title="Link target outside of Sample">Chapter 31: He’s Maybe Mr. Right</span></p>
<p><span href="#/036#a96" title="Link target outside of Sample">Chapter 32: Body Parts</span></p>
<p><span href="#/037#a97" title="Link target outside of Sample">Chapter 33: King Time</span></p>
<p><span href="#/038#a98" title="Link target outside of Sample">Chapter 34: Bear Blog, August 15</span></p>
<p><span href="#/039#a99" title="Link target outside of Sample">Chapter 25: Breaking Rules</span></p>
<p><span href="#/040#a100" title="Link target outside of Sample">Chapter 36: The Final Piece of the Puzzle</span></p>
<p><span href="#/041#a101" title="Link target outside of Sample">Chapter 37: This Can’t Be Happening</span></p>
<p><span href="#/042#a102" title="Link target outside of Sample">Chapter 38: Minding Matters</span></p>
<p><span href="#/043#a103" title="Link target outside of Sample">Chapter 39: Nothing Happened</span></p>
<p><span href="#/044#a104" title="Link target outside of Sample">Chapter 40: Bear Blog, August 28</span></p>
<p> </p>
<p class="p1"><span href="#/045#a105" title="Link target outside of Sample">Part 5: Jim Bone</span></p>
<p><span href="#/045#a106" title="Link target outside of Sample">Chapter 41: Millard LeCarre</span></p>
<p><span href="#/046#a107" title="Link target outside of Sample">Chapter 42: The Bear’s Den</span></p>
<p><span href="#/047#a108" title="Link target outside of Sample">Chapter 43: The Favor</span></p>
<p><span href="#/048#a109" title="Link target outside of Sample">Chapter 44: Uninterested</span></p>
<p><span href="#/049#a110" title="Link target outside of Sample">Chapter 45: Ending Things like Polite Men</span></p>
<p><span href="#/050#a111" title="Link target outside of Sample">Chapter 46: Sunlight</span></p>
<p><span href="#/051#a112" title="Link target outside of Sample">Chapter 47: Bear Blog, Jim Bone 1</span></p>
<p><span href="#/052#a113" title="Link target outside of Sample">Chapter 48: A Late Evening Visit</span></p>
<p><span href="#/053#a114" title="Link target outside of Sample">Chapter 49: Sometimes You Can’t Help Who You Fall For</span></p>
<p><span href="#/054#a115" title="Link target outside of Sample">Chapter 50: Fool</span></p>
<p> </p>
<p class="p1"><span href="#/055#a116" title="Link target outside of Sample">Epilogue: December 20</span></p>
<p> </p>
<p class="p0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?ea3ccdcc